// extracted by mini-css-extract-plugin
export default {"markdown":"markdown-price__markdown___1G14-","original-price":"markdown-price__original-price___xj28m","percentage-saved":"markdown-price__percentage-saved___3-OLP"};